<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div class="mt-4">
      <b-row>
        <b-col>
          <b-card>
            <template v-slot:header>
              <strong>Queued Reports</strong>
              <button id="btnRefresh" class="btn btn-primary pull-right" @click="refreshHistory">
                <strong class="text-white">Refresh</strong>
              </button>
            </template>
            <b-table :items="runningReports" :fields="runningReportFields" hover striped bordered small :current-page="currentPage" :per-page="perPage" show-empty>

              <template v-slot:cell(perc_done)="data">
                <div class="progress" style="background-color: #a8dcff;">
                  <div class="progress-bar progress-bar-striped progress-bar-animated"
                       v-bind:style="{ width: data.value + '%' }">{{data.value}}%</div>
                </div>
              </template>
              <template v-slot:cell(msg)="data">
                <div style="min-width:50px">{{data.value}}&nbsp;</div>
              </template>
              <template v-slot:cell(cancel)="data">
                <div style="min-width:50px"><a href="#" class="btn btn-danger btn-sm" @click="CancelReport(data)">Cancel</a></div>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-card>
            <template v-slot:header>
              <strong>Report History</strong>
            </template>

            <b-row>
              <div class="headerCategory mr-1 bordered" style="display:flex;flex:2; ">
                <div class="category_title m-0">
                  <b-form-input type="text" placeholder="New Category" v-model="NewCategory" class="form-control" size="sm" />
                </div>
                <div class="" @click="AddCustomCategory()">
                  <button><i class="fa fa-plus ml-1 mr-1 pt-1 " size="sm"></i></button>
                </div>
              </div>
              <div class="headerCategory " style="display:flex;flex:2;">
                <div class="category_title m-0">
                  <b-form-input type="text" v-model="searchValue" placeholder="Search" class="form-control" size="sm" />
                  <button @click="searchReport()"><i class="fa fa-search ml-1 mr-1 pt-1"></i>  </button>
                </div>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:2;">
                <b-form-select v-model="SelectedFolder" :options="Folders" @change="ChangedFolder()" size="sm" class="form-control" style="max-width:12em">
                </b-form-select>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:2;justify-content:start;">
                <label style="margin-left:10px;margin-top:7px;">Filtered [{{this.filteredReports.length}}]</label>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:4; ">
                <div class="ml-3 mr-1">
                  Move To
                </div>
                <div class="category_title m-0">
                  <b-form-select v-model="MoveCategory" :options="TransferCategories" size="sm" class="form-control"
                                 value-field="Id" style="max-width:12em"
                                 text-field="Name">
                  </b-form-select>
                  <b-button variant="success" @click="moveSelectionToCategory()" size="sm"><i class="fa fa-exchange ml-2 mr-2 pt-1"></i></b-button>

                </div>
                <div class="ml-2 mr-2">
                  Select All
                </div>
                <div class="m-0 mr-2 text-right">
                  <input type="checkbox" @change="selectAll" v-model="IsAllSelection" style="display:flex;align-self:center;margin-right:10px;" class="" />
                </div>
              </div>

            </b-row>
            <b-row>
              <div class="categories mr-1 bordered">
                <drop v-if="HasValue(data) && HasValue(data.Unassigned) && HasValue(data.Unassigned.Reports)" class="category " v-bind:class="{ 'category_selected': boolLoading===false && IsCategorySelected(data.Unassigned.Id) } "
                      @drop="function(transferData, nativeEvent) { handleDropCustom(data.Unassigned, transferData, nativeEvent) }"
                      ref="data.Unassigned">
                  <div class="category_title " @click="SetActive(data.Unassigned)">
                    Unassigned ({{data.Unassigned.Reports.length}})
                  </div>
                  <div class="category_action">

                  </div>
                </drop>
                <drop v-if="HasValue(data) && HasValue(data.ReportHistory) && HasValue(data.ReportHistory.Favorites)" class="category" v-bind:class="{ 'category_selected': boolLoading===false && IsCategorySelected(data.ReportHistory.Favorites.Id) }"
                      @drop="function(transferData, nativeEvent) { handleDropCustom(data.ReportHistory.Favorites, transferData, nativeEvent) }"
                      ref="data.ReportHistory.Favorites">
                  <div class="category_title" @click="SetActive(data.ReportHistory.Favorites)">
                    Favorites ({{data.ReportHistory.Favorites.Reports.length}})
                  </div>
                  <div class="category_action">
                    <i class="fa fa-star ml-2"></i>
                  </div>
                </drop>
                <div v-if="HasValue(data) && HasValue(data.ReportHistory)">
                  <drop v-if="HasValue(data.ReportHistory.CustomCategories)" class="customCategory" v-for="category in data.ReportHistory.CustomCategories"
                        v-bind:class="{ 'category_selected':boolLoading===false && IsCategorySelected(category.Id) }" ref="category"
                        @drop="function(transferData, nativeEvent) { handleDropCustom(category, transferData, nativeEvent) }"  >
                    <div class="category_title" @click="SetActive(category)">
                      {{category.Name}} ({{category.Reports.length}})
                    </div>
                    <div class="category_action">
                      <a href="#" @click="archiveCategory(category)"><i class="fa fa-trash ml-2"></i></a>
                    </div>
                  </drop>
                </div>
                <drop v-if="HasValue(data) && HasValue(data.ReportHistory) && HasValue(data.ReportHistory.Archive)" class="category" v-bind:class="{ 'category_selected':boolLoading===false && IsCategorySelected(data.ReportHistory.Archive.Id) }"
                      @drop="function(transferData, nativeEvent) { handleDropCustom(data.ReportHistory.Archive, transferData, nativeEvent) }"
                      ref="data.ReportHistory.Archive">
                  <div class="category_title" @click="SetActive(data.ReportHistory.Archive)">
                    Archive ({{data.ReportHistory.Archive.Reports.length}})
                  </div>
                  <div class="category_action">

                  </div>
                </drop>
              </div>
              <div cols="10" class="reports">
                <div class="report_row_slim_header">
                  <div class="report_id">History ID</div>
                  <div class="report_template_name"><span>Title</span></div>
                  <div class="report_category">Category</div>
                  <div class="report_user">User</div>
                  <div class="report_date">Report Date</div>
                  <div class="report_xls">Outputs</div> 
                  <div class="report_json">&nbsp;</div>
                  <div class="report_action">Actions</div>
                </div>
                <drag class="report_row" v-for="report in filteredReports" :transfer-data="report" v-bind:class="{report_row_hover : report.IsSelected===true}">
                  <div class="report_id">{{report.report_id}}</div>
                  <div class="report_template_name"><span>{{report.JObjectContent.title | To50MaxChars}}</span></div>
                  <div class="report_category">{{report.CategoryName}}</div>
                  <div class="report_user">{{report.JObjectContent.createdby}}</div>
                  <div class="report_date">{{report.JObjectContent.created }}</div>
                  <div class="report_xls"> <label v-if="report.JObjectContent.billable === false">CANCELLED</label> <a v-if="report.JObjectContent.excel  && report.JObjectContent.billable" href="#" @click="DownloadReport(report.JObjectContent.excel)">XLS</a></div>
                  <div class="report_json"><a v-if="report.JObjectContent.json && report.JObjectContent.billable" href="#" @click="DownloadReport(report.JObjectContent.json)">JSON</a></div>
                  <div class="report_action" style="display:flex;flex-flow:row">
                    <a href="#" style="display:flex"
                       v-if="SelectedCategory.Name!=='Archive'"
                       @click="moveReportToArchive(report)"><i class="fa fa-trash ml-2"></i></a>
                    <a href="#" class="ml-3"
                       v-if="SelectedCategory.Name!=='Favorites'"
                       style="display:flex" @click="moveReportToFavorites(report)">
                      <i class="fa fa-star ml-2"></i>
                    </a>
                    <input type="checkbox" v-model="report.IsSelected" value="true" unchecked-value="false" style="display:flex;align-self:center;" class="ml-3" />
                  </div>
                </drag>
              </div>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>
<script>

import Vue from 'vue'
import axios from 'axios'
import Store from '@/store'
import loading from 'vue-full-loading'
import Vue2Filters from 'vue2-filters'
import { setTimeout } from 'timers'
// import moment from 'moment'
// import { cat } from 'shelljs'
import { Drag, Drop } from 'vue-drag-drop'

Vue.use(Vue2Filters)
export default {
  name: 'mScopeReportHistory',
  components: {
    loading,
    'drag': Drag,
    'drop': Drop
  },
  created () {
    this.boolLoading = true
    let self = this
    this.Folders = [{ 'value': 1, 'text': 'Current Category' }, { 'value': 2, 'text': 'All Categories' }]
    this.SelectedFolder = this.Folders[0].value
    this._FAVORITES = 1
    this._UNASSIGNED = 2
    this._ARCHIVES = 3
    setTimeout(function () {
      self.initLoad = true
    }, 10000)
    self.LoadHistory()
    self.interval = setInterval(() => self.LoadRunningReports(), 2000)
    // setTimeout(function () {
    //  if (self.interval !== undefined) { clearInterval(self.interval) }
    // }, 180000)
  },
  data () {
    return {
      errMsg: '',
      isDragging: false,
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      initLoad: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      isInternalStaff: Store.state.isInternalStaff || Store.state.isRustyAccount,
      filterUnrec: false,
      filterCertified: false,
      tbxFilter: '',
      processedReports: [],
      unassignedReports: [],
      data: {},
      filteredReports: [],
      SelectedReports: [],
      NewCategory: '',
      searchValue: '',
      runningReports: [],
      SelectedCategory: {},
      TransferCategories: [],
      MoveCategory: {},
      IsAllSelection: false,
      Folders: [],
      SelectedFolder: {},
      _FAVORITES: 1,
      _UNASSIGNED: 2,
      _ARCHIVES: 3,
      AllFolders: [],
      divs: [],
      processedReportFields: [
        { key: 'created', label: 'Created', sortable: true },
        { key: 'createdby', label: 'Created By', sortable: true },
        { key: 'title', label: 'Title', sortable: true },
        { key: 'excel', label: 'Excel', sortable: false },
        { key: 'html', label: 'HTML', sortable: false },
        { key: 'json', label: 'JSON', sortable: false },
        { key: 'blank', label: '', sortable: false }
      ],
      runningReportFields: [
        { key: 'started', label: 'Started', sortable: true },
        { key: 'title', label: 'Title', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'perc_done', label: 'Progress', sortable: false },
        { key: 'msg', label: '', sortable: false },
        { key: 'cancel', label: '', sortable: false }
      ],
      currentPage: 1,
      perPage: 1000,
      totalRows: 0,
      externalReport: false
    }
  },
  watch: {
    runningReports: {
      handler: function (val, oldVal) {
        if (val.length !== oldVal.length) { this.LoadHistory() }
      },
      deep: true
    }
  },
  methods: {
    HasValue (val) {
      return val !== undefined && val !== null
    },
    externalReporting () {
      this.canFilter = true
      let params = JSON.parse(localStorage.getItem('externalReportHistory'))
      if (params !== null && params !== '' && params !== undefined) {
        this.SelectedFolder = this.Folders[1].value
        this.searchValue = params.report_id
        this.searchReport()
        if (this.externalReport) {
          localStorage.removeItem('externalReportHistory')
          this.externalReport = false
        }
        this.externalReport = true
      }
    },
    handleDropCustom (category, data, event) {
      if (typeof data !== 'undefined') {
        let reports = this.filteredReports.filter(x => this.IsSelected(x))
        if (reports.length === 0) {
          if (category.Id !== data.categoryId) { this.moveReportToCategory(data, category.Id) } else { alert('Please do not drop the selection in the same category!') }
        } else {
          this.moveSelectedReportsToCategory(reports, category.Id)
        }
      }
    },
    refreshHistory () {
      let self = this
      self.boolLoading = true
      self.LoadHistory()
      // if (self.interval === undefined) {
      //  self.interval = setInterval(() => self.LoadRunningReports(), 30000)
      //  setTimeout(function () {
      //    if (self.interval !== undefined) { clearInterval(self.interval) }
      //  }, 180000)
      // }
    },
    AddCustomCategory () {
      let self = this
      let StaticCategories = 3
      if (!(self.NewCategory !== null && self.NewCategory.length > 0)) {
        this.errMsg = 'The Category Name is empty'
        this.showDismissibleAlert = true
        return
      }

      if (self.data.ReportHistory.CustomCategories.filter(x => x.Name === self.NewCategory).length === 0) {
        if (confirm('This will save the changes you have made. Are you sure?')) {
          let max = StaticCategories
          if (this.data.ReportHistory.CustomCategories.length > 0) {
            let maxElement = this.data.ReportHistory.CustomCategories.reduce(function (prev, current) {
              return (prev.Id > current.Id) ? prev : current
            })
            max = maxElement.Id
          }
          const CustomCategory = {
            'Id': max + 1,
            'Name': self.NewCategory,
            'Reports': []
          }
          self.data.ReportHistory.CustomCategories.push(CustomCategory)
          this.setTransferCategories(self.data)
          self.NewCategory = ''
          this.SaveChanges()
        }
      } else {
        this.errMsg = 'The Category Name is already in the list'
        this.showDismissibleAlert = true
      }
    },

    selectAll () {
      if (this.IsAllSelection === true) {
        for (let i = 0; i < this.filteredReports.length; i++) {
          let element = this.filteredReports[i]
          element['IsSelected'] = true
        }
      } else {
        for (let i = 0; i < this.filteredReports.length; i++) {
          let element = this.filteredReports[i]
          element['IsSelected'] = false
        }
      }
    },
    archiveCategory (category) {
      let confirmMessage = confirm("Your report(s) will not be deleted. Note: The report(s) will be moved to the 'Archive' Section")
      if (confirmMessage === true) {
        this.MoveSelectedReportsToDifferentCategory(category.Reports, category.Id, this._ARCHIVES, false, false)
        this.deleteEmptyCategory(category, false)
      }
    },
    deleteEmptyCategory (category) {
      for (let i = 0; i < this.data.ReportHistory.CustomCategories.length; i++) {
        let customcategory = this.data.ReportHistory.CustomCategories[i]
        if (customcategory.Id === category.Id) {
          this.data.ReportHistory.CustomCategories.splice(i, 1)
          break
        }
      }
      this.SelectedCategory = this.data.Unassigned
      this.SaveChanges()
    },
    moveReportToFavorites (report) {
      let confirmMessage = confirm('Are you sure you want to make the following change? NOTE: The report will be moved to the Category Assign.')
      if (confirmMessage === true) {
        let SelectedElements = []
        SelectedElements.push(report)
        this.MoveSelectedReportsToDifferentCategory(SelectedElements, report.categoryId, this._FAVORITES, true, false)
      }
    },

    moveReportToArchive (report) {
      let confirmMessage = confirm("Your report(s) will not be deleted. Note: The report(s) will be moved to the 'Archive' Section")
      if (confirmMessage === true) {
        let SelectedElements = []
        SelectedElements.push(report)
        this.MoveSelectedReportsToDifferentCategory(SelectedElements, report.categoryId, this._ARCHIVES, true, false)
      }
    },

    moveSelectionToCategory () {
      let confirmMessage = confirm('Are you sure you want to make the following change? NOTE: The report(s) will be moved to the Category Assign.')
      if (confirmMessage === true) {
        let SelectedElements = []
        this.SelectedReports.filter(x => this.IsSelected(x)).forEach(function (report) {
          SelectedElements.push(report)
        })
        this.MoveSelectedReportsToDifferentCategory(SelectedElements, this.SelectedCategory.Id, this.MoveCategory, true, false)
      }
    },
    moveSelectedReportsToCategory (SelectedElements, CategoryIdToMove) {
      let confirmMessage = confirm('Are you sure you want to make the following change? NOTE: The report(s) will be moved to the Category Assign.')
      if (confirmMessage === true) {
        let QtyInTheSameCategory = 0
        for (let i = 0; i < SelectedElements.length; i++) {
          let reportsels = []
          reportsels.push(SelectedElements[i])
          if (SelectedElements[i].categoryId !== CategoryIdToMove) { this.MoveSelectedReportsToDifferentCategory(reportsels, SelectedElements[i].categoryId, CategoryIdToMove, true, false) } else { QtyInTheSameCategory++ }
        }
        if (QtyInTheSameCategory > 0) {
          alert('[' + QtyInTheSameCategory + '] selected reports were already in the final category')
        }
      }
    },
    moveReportToCategory (report, CategoryIdToMove) {
      let confirmMessage = confirm('Are you sure you want to make the following change? NOTE: The report will be moved to the Category Assign.')
      if (confirmMessage === true) {
        let SelectedElements = []
        SelectedElements.push(report)
        this.MoveSelectedReportsToDifferentCategory(SelectedElements, this.SelectedCategory.Id, CategoryIdToMove, true, false)
      }
    },

    IsSelected (report) {
      return (typeof report['IsSelected'] !== 'undefined' && report.IsSelected === true)
    },
    MoveSelectedReportsToDifferentCategory (SelectedElements, CategoryIdFrom, CategoryIdTo, Save, SaveMessage) {
      let res = true
      if (SaveMessage === true) {
        res = confirm('This will save the changes you have made. Are you sure?')
      }
      if (res === false) {
        return
      }

      let from = this.GetStrCategory(CategoryIdFrom)
      let to = this.GetStrCategory(CategoryIdTo)

      if (to === 'Favorites') {
        this.addReportsTo(SelectedElements, this.data.ReportHistory['Favorites'], CategoryIdTo)
      }
      if (to === 'Archive') {
        this.addReportsTo(SelectedElements, this.data.ReportHistory['Archive'], CategoryIdTo)
      }
      if (to === 'CustomCategories') {
        this.addReportsToCustomCategory(SelectedElements, this.data.ReportHistory['CustomCategories'], CategoryIdTo)
      }
      if (to === 'Unassigned') {
        this.addReportsTo(SelectedElements, this.data['Unassigned'], CategoryIdTo)
      }

      this.filteredReports = this.filteredReports.filter(x => this.IsNotSelectedReport(x, SelectedElements))

      // FROM
      if (from === 'Favorites') {
        this.removeReportsFrom(SelectedElements, this.data.ReportHistory['Favorites'])
      }
      if (from === 'Unassigned') {
        this.removeReportsFrom(SelectedElements, this.data['Unassigned'])
      }
      if (from === 'Archive') {
        this.removeReportsFrom(SelectedElements, this.data.ReportHistory['Archive'])
      }
      if (from === 'CustomCategories') {
        this.removeReportsFromCustomCategory(SelectedElements, this.data.ReportHistory['CustomCategories'], CategoryIdFrom)
      }
      if (Save) { this.SaveChanges() }
      if (this.IsAllSelection !== false) {
        this.IsAllSelection = false
      }
      // setA
    },
    IsNotSelectedReport (report, SelectedElements) {
      return (SelectedElements.filter(x => x.report_id === report.report_id).length === 0)
    },
    addReportsToCustomCategory (SelectedElements, CustomCategories, CategoryId) {
      for (let i = 0; i < CustomCategories.length; i++) {
        let category = CustomCategories[i]
        if (category.Id === CategoryId) {
          this.addReportsTo(SelectedElements, category, CategoryId)
          break
        }
      }
    },
    removeReportsFromCustomCategory (SelectedElements, CustomCategories, CategoryId) {
      for (let i = 0; i < CustomCategories.length; i++) {
        let category = CustomCategories[i]
        if (category.Id === CategoryId) {
          this.removeReportsFrom(SelectedElements, category)
          break
        }
      }
    },
    getAllFolders () {
      let AllFolders = []
      if (this.SelectedFolder === 2) {
        this.data.Unassigned.Reports.forEach(function (report) {
          AllFolders.push(report)
        })
        this.data.ReportHistory.Favorites.Reports.forEach(function (report) {
          AllFolders.push(report)
        })
        this.data.ReportHistory.Archive.Reports.forEach(function (report) {
          AllFolders.push(report)
        })
        this.data.ReportHistory.CustomCategories.forEach(function (category) {
          category.Reports.forEach(function (report) {
            AllFolders.push(report)
          })
        })
      }
      return AllFolders
    },

    SetActive (category) {
      this.SelectedCategory = category
      this.SelectedReports = this.filteredReports = category.Reports
      this.setTransferCategories(this.data)
    },
    IsCategorySelected (Id) {
      return Id === this.SelectedCategory.Id
    },
    GetStrCategory (categoryId) {
      if (categoryId === this._FAVORITES) { return 'Favorites' }
      if (categoryId === this._ARCHIVES) { return 'Archive' }
      if (categoryId === this._UNASSIGNED) { return 'Unassigned' }
      return 'CustomCategories'
    },

    addReportsTo (reports, ReportHistoryCategoryArrayDestiny, CategoryIdTo) {
      reports.forEach(function (report) {
        report.categoryId = CategoryIdTo
        report.JObjectContent.CategoryId = CategoryIdTo
        ReportHistoryCategoryArrayDestiny.Reports.push(report)
      })
    },
    removeReportsFrom (SelectedReports, ReportHistoryCategoryArraySource) {
      let ids = []
      SelectedReports.forEach(function (report) {
        for (let i = 0; i < ReportHistoryCategoryArraySource.Reports.length; i++) {
          if (ReportHistoryCategoryArraySource.Reports[i].report_id === report.report_id) {
            const reportId = report.report_id
            ids.push(reportId)
            ReportHistoryCategoryArraySource.Reports.splice(i, 1)
            break
          }
        }
      })
      this.RemoveFromSelectedReport(ids)
    },
    RemoveFromSelectedReport (reportIds) {
      for (let j = 0; j < reportIds.length; j++) {
        for (let x = 0; x < this.SelectedReports.length; x++) {
          if (this.SelectedReports[x].report_id === reportIds[j]) {
            this.SelectedReports.splice(x, 1)
            break
          }
        }
      }
    },
    removeReportFromSourceCategory (reportId, CategoryId) {
      if (CategoryId === 1) {
        for (let i = 0; i < this.data['Unassigned'].Reports.length; i++) {
          this.data['Unassigned'].Reports.splice(i, 1)
          break
        }
      } else if (CategoryId === 2) {
        for (let i = 0; i < this.data.ReportHistory['Favorites'].Reports.length; i++) {
          this.data.ReportHistory['Favorites'].Reports.splice(i, 1)
          break
        }
      } else if (CategoryId === 3) {
        for (let i = 0; i < this.data.ReportHistory['Archive'].Reports.length; i++) {
          this.data.ReportHistory['Archive'].Reports.splice(i, 1)
          break
        }
      } else if (CategoryId > 3) {
        for (let i = 0; i < this.data.ReportHistory['CustomCategories'].length; i++) {
          let category = this.data.ReportHistory['CustomCategories'][i]
          if (category.Id === CategoryId) {
            for (let i = 0; i < category.Reports.length; i++) {
              let report = category.Reports[i]
              if (report.report_id === reportId) {
                category.Reports.splice(i, 1)
                break
              }
            }
            break
          }
        }
      }
    },
    searchReport () {
      let self = this
      if (this.SelectedFolder === 1) {
        self.filteredReports = self.SelectedReports.filter(x =>
          x.JObjectContent.title.toUpperCase().indexOf(self.searchValue.toUpperCase()) !== -1 ||
          x.JObjectContent.report_id === ('' + self.searchValue) ||
          x.JObjectContent.createdby.toUpperCase().indexOf(self.searchValue.toUpperCase()) !== -1
        )
      } else {
        self.filteredReports = self.getAllFolders().filter(x =>
          x.JObjectContent.title.toUpperCase().indexOf(self.searchValue.toUpperCase()) !== -1 ||
          x.JObjectContent.report_id === ('' + self.searchValue) ||
          x.JObjectContent.createdby.toUpperCase().indexOf(self.searchValue.toUpperCase()) !== -1
        )
      }
    },

    DownloadReport (download) {
      this.boolLoading = true
      const options = {
        method: 'POST',
        data: download,
        responseType: 'blob',
        url: '/api/mscope/downloadreport'
      }
      axios(options)
        .then(response => {
          this.boolLoading = false
          const fileName = response.headers['content-disposition'].split('filename=')[1]
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    LoadHistory () {
      axios.get('/api/mscope/loadhistory')
        .then(response => {
          this.data = response.data
          this.filteredReports = this.SelectedReports = this.data.Unassigned.Reports
          this.SelectedCategory = this.data.Unassigned
          this.setTransferCategories(this.data)
          this.boolLoading = false
          this.initLoad = false
          if (localStorage.getItem('PendingReport') != null && localStorage.getItem('PendingReport') !== undefined) {
            localStorage.setItem('PendingReport', '' + (parseInt(localStorage.getItem('PendingReport')) + 1))
          }
          if (localStorage.getItem('PendingReport') === 2) {
            this.externalReporting()
            localStorage.removeItem('PendingReport')
            localStorage.removeItem('externalReportHistory')
          }
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    ChangedFolder () {
      this.setTransferCategories(this.data)
    },
    setTransferCategories (data) {
      let tCategories = []

      // let unassigned = {
      //   Id: data.Unassigned.Id,
      //   Name: data.Unassigned.Name
      // }
      // let favorites = {
      //   Id: data.ReportHistory.Favorites.Id,
      //   Name: data.ReportHistory.Favorites.Name
      // }
      // let Archive = {
      //   Id: data.ReportHistory.Favorites.Id,
      //   Name: data.ReportHistory.Favorites.Name
      // }

      if (this.SelectedFolder === 2) {
        tCategories.push(data.Unassigned)
        tCategories.push(data.ReportHistory.Favorites)
        tCategories.push(data.ReportHistory.Archive)
        for (let i = 0; i < data.ReportHistory.CustomCategories.length; i++) {
          let category = data.ReportHistory.CustomCategories[i]
          tCategories.push(category)
        }
      } else {
        if (this.SelectedCategory.Id !== data.Unassigned.Id) {
          tCategories.push(data.Unassigned)
        }
        if (this.SelectedCategory.Id !== data.ReportHistory.Favorites.Id) {
          tCategories.push(data.ReportHistory.Favorites)
        }
        if (this.SelectedCategory.Id !== data.ReportHistory.Archive.Id) {
          tCategories.push(data.ReportHistory.Archive)
        }

        for (let i = 0; i < data.ReportHistory.CustomCategories.length; i++) {
          let category = data.ReportHistory.CustomCategories[i]
          if (this.SelectedCategory.Id !== category.Id) {
            tCategories.push(category)
          }
        }
      }

      this.TransferCategories = tCategories
      this.MoveCategory = tCategories[0].Id
    },
    SaveChanges () {
      this.boolLoading = true

      axios.post('/api/mscope/savereporthistorycategory', this.data.ReportHistory)
        .then(response => {
          this.data = response.data
          this.filteredReports = this.SelectedReports = this.data.Unassigned.Reports
          this.boolLoading = false
          this.initLoad = false
          this.SetActive(this.SelectedCategory)
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    LoadRunningReports () {
      axios.get('/api/mscope/loadrunningreports')
        .then(response => {
          this.runningReports = response.data.runningReports
        })
    },
    CancelReport (data) {
      const self = this
      if (confirm('Are you sure you want to cancel this report?')) {
        axios.post('/api/mscope/cancelReport', data)
          .then(response => {
            setTimeout(function () {
              self.refreshHistory()
            }, 1000)
          })
          .catch(error => {
            if (error.response.status === 403) {
              self.$router.push('/login')
            }
          })
      }
    },
    DeleteReport (report) {
      const self = this
      if (report === undefined) {
        if (confirm('This will clear all report history for this account. Are you sure?')) {
          const options = {
            method: 'POST',
            data: { 'item': { 'report_id': -1 } },
            responseType: 'blob',
            url: '/api/mscope/deletereport'
          }
          axios(options)
            .then(response => {
              self.refreshHistory()
            })
            .catch(error => {
              if (error.response.status === 403) {
                self.$router.push('/login')
              }
            })
        }
      } else {
        if (confirm('Are you sure you want to delete this?')) {
          const options = {
            method: 'POST',
            data: report,
            responseType: 'blob',
            url: '/api/mscope/deletereport'
          }
          axios(options)
            .then(response => {
              self.refreshHistory()
            })
            .catch(error => {
              if (error.response.status === 403) {
                self.$router.push('/login')
              }
            })
        }
      }
    }
  },
  filters: {
    formatDate: function (str) {
      if (!str) { return '' }
      str = new Date(str)
      return str.toString()
      // return ((str.getMonth() < 9) ? '0' : '') + (str.getMonth() + 1) + '/' + ((str.getDate() < 10) ? '0' : '') + str.getDate() + '/' + str.getFullYear() + ' ' + str.getTime()
    },
    To50MaxChars: function (str) {
      if (!str) { return '' }
      return str.substring(0, 50)
    }
  },
  beforeDestroy: function () {
    let self = this
    if (self.interval !== undefined) { clearInterval(self.interval) }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
    this.initLoad = false
  }
}
</script>
<style>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }
  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px 0.3rem;
  }
  .table-xtra-condensed.table {
    margin-bottom: initial !important;
  }
  body {
    background-color: initial;
  }
  .progress-bar {
    min-width:15px;
  }
  .bordered {
    border:1px solid lightgray;
  }
  .reports {
    display: flex;
    flex:10;
    flex-flow: column;
    border: 1px solid lightgray;
    max-height: 500px;
    min-height: 300px;
    overflow-y:auto;
  }
  .report_row {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding-bottom: 5px;
    padding-top: 5px;
    transition: 0.3s;
  }

  .report_row_hover {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding-bottom: 5px;
    padding-top: 5px;
    background-color: #f0f3f5;
    /*font-weight: bold;*/
  }

  .report_row:hover {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding-bottom: 5px;
    padding-top: 5px;
    background-color: #eae1e1;
    /*font-weight: bold;*/
  }

  .category {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 40px;
    justify-content: center;
    align-items: center;
    font-weight:100;
    transition: 0.3s;
  }
  .category:hover {
    background-color: #ddd;
    opacity: 0.6;
  }
  .category_selected {
    background-color: #ddd;
    font-weight: bold;
  }

  .headerCategory {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    /*height: 40px;*/
    justify-content: center;
    align-items: center;
    background-color: #f0f3f5;
  }
  .customCategory {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 40px;
    justify-content: center;
    align-items: center;
    transition: 0.3s;
  }
  .customCategory:hover {
    background-color: #ddd;
    opacity: 0.6;
  }

  .categories {
    display: flex;
    flex: 2;
    flex-flow: column;
    width: 250px;
  }
  .category_action {
    display: flex;
    flex: 2;
    margin-right:10px;
  }
  .category_title {
    display: flex;
    flex: 10;
    margin-left: 10px;
  }
  .report_id {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left:10px;

  }
  .report_template_name {
    display: flex;
    flex-flow: column;
    flex: 5;
    padding-left: 3px;
  }
  .report_user {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .report_category {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .report_date {
    display: flex;
    flex-flow: column;
    flex: 2;
    padding-left: 3px;
  }
  .report_time {
    display: flex;
    flex-flow: column;
    flex: 1;
  }
  .report_xls {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  } 
  .report_json {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .report_action {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/views/mScopeReportHistory.vue